import axios from "axios";
// import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

export default {
  // Levels Actions ------------------------------------------------------------------
  getLevels({ dispatch, commit }) {
    axios
      .get("dropdown/level")
      .then((res) => {
        commit("setLevels", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Lebels Actions ------------------------------------------------------------------
  getLabels({ dispatch, commit }) {
    axios
      .get("dropdown/label")
      .then((res) => {
        commit("setLabels", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Province Actions ------------------------------------------------------------------
  getCountries({ dispatch, commit }) {
    axios
      .get("customer/CustomerDropDown/Countries")
      .then((res) => {
        commit("setCountries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProvinces({ dispatch, commit }, data) {
    axios
      .get("customer/CustomerDropDown/Provinces?countryId=" + data)
      .then((res) => {
        commit("setProvinces", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCities({ dispatch, commit }, data) {
    axios
      .get("customer/CustomerDropDown/Cities?provinceId=" + data)
      .then((res) => {
        commit("setCities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRegions({ dispatch, commit }, data) {
    axios
      .get("customer/CustomerDropDown/Regions?cityId=" + data)
      .then((res) => {
        commit("setRegions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Banks Actions ------------------------------------------------------------------
  getBanks({ dispatch, commit }) {
    axios
      .get("dropdown/bank")
      .then((res) => {
        commit("setBanks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // VendorCategory Actions ------------------------------------------------------------------
  getVendorCategory({ dispatch, commit }) {
    axios
      .get("dropdown/vendorCategory")
      .then((res) => {
        commit("setVendorCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getVendor({ dispatch, commit }, data) {
    axios
      .get("dropdown/vendor/" + data)
      .then((res) => {
        commit("setVendor", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getVendors({ dispatch, commit }) {
    axios
      .get("dropdown/vendors")
      .then((res) => {
        commit("setVendors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

 // Customers Options ----------------------------------------------------------
   getCustomers({ dispatch, commit }) {
     axios
       .get("dropdown/customer")
       .then((res) => {
         commit("setCustomers", res.data.data);
       })
       .catch((error) => {
         dispatch("errorGETHandler", error, { root: true });
       });
   },

};
